(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rd-gallery-category')) {
    customElements.define('rd-gallery-category', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('.rd-gallery__cover')];
        this.dots = [...this.querySelectorAll('.rd-gallery__dot')];
        this.button = this.querySelector('.rd-gallery__pause');
        if (this.slides.length < 2 || !this.button) return;
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.visible = false;
        this.hoverPaused = false;
        this.focusPaused = false;
        this.button.hidden = false;
        this.updateButton();
        this.button.addEventListener('click', () => { this.paused = !this.paused; if (!this.paused) { this.hoverPaused = false; this.focusPaused = false; } this.updateButton(); this.schedule(); }, options);
        this.addEventListener('mouseenter', () => { this.hoverPaused = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hoverPaused = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focusPaused = true; this.schedule(); }, options);
        this.addEventListener('focusout', () => setTimeout(() => { if (this.isConnected) { this.focusPaused = this.contains(document.activeElement); this.schedule(); } }, 0), options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.updateButton(); this.schedule(); }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.2 });
        this.observer.observe(this);
      }
      updateButton() {
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.button.setAttribute('aria-label', (this.paused ? this.dataset.playLabel : this.dataset.pauseLabel) + ': ' + this.button.dataset.heading);
        this.button.querySelector('span').textContent = this.paused ? '▶' : '❚❚';
      }
      canPlay() { return this.isConnected && this.visible && !this.paused && !document.hidden && !this.hoverPaused && !this.focusPaused; }
      schedule() {
        clearTimeout(this.timer);
        if (!this.canPlay()) return;
        this.timer = setTimeout(async () => {
          const next = (this.index + 1) % this.slides.length;
          const image = this.slides[next];
          try { await image.decode(); } catch { this.schedule(); return; }
          if (!this.canPlay()) return;
          this.slides[this.index].classList.remove('is-active');
          this.dots[this.index]?.classList.remove('is-active');
          image.classList.add('is-active');
          this.dots[next]?.classList.add('is-active');
          this.index = next;
          this.schedule();
        }, 5200 + Number(this.dataset.offset || 0));
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-gothic-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rd-gothic-collection')) {
    customElements.define('rd-gothic-collection', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.filters = this.querySelector('.rd-gothic__filters');
        this.buttons = Array.from(this.querySelectorAll('[data-filter]'));
        this.cards = Array.from(this.querySelectorAll('[data-category]'));
        this.counter = this.querySelector('.rd-gothic__count');
        this.buttons.forEach(button => button.addEventListener('click', () => this.filter(button.dataset.filter), options));
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-category]');
          if (card) this.filter('all');
        }, options);
        if (this.filters) this.filters.hidden = false;
      }
      filter(category) {
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
        let count = 0;
        this.cards.forEach(card => {
          card.hidden = category !== 'all' && card.dataset.category !== category;
          if (!card.hidden) count += 1;
        });
        if (this.counter) this.counter.textContent = this.dataset.countTemplate.replace('[count]', String(count));
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-home-welcome"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rd-home-showcase')) {
    customElements.define('rd-home-showcase', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.slides = Array.from(this.querySelectorAll('[data-showcase-slide], template[data-showcase-template]'));
        if (this.slides.length < 2) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('[data-showcase-track]');
        this.count = this.querySelector('[data-showcase-count]');
        this.toggleIcon = this.querySelector('[data-showcase-toggle-icon]');
        this.toggleLabel = this.querySelector('[data-showcase-toggle-label]');
        this.toggle = this.querySelector('[data-showcase-toggle]');
        this.jump = this.querySelector('[data-showcase-jump]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.paused = this.motion.matches || this.mobile.matches;
        this.hovered = false;
        this.focused = this.contains(document.activeElement);
        this.playThroughFocus = false;
        this.playThroughHover = false;
        this.visible = false;
        this.index = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
        this.reserveCaptionHeight();
        this.querySelector('[data-showcase-controls]').hidden = false;
        if (this.slides.length > 6 && this.jump) {
          this.jump.replaceChildren(...this.slides.map((slide, index) => {
            const option = document.createElement('option');
            option.value = String(index);
            option.textContent = this.dataset.reviewLabel.replace('[number]', String(index + 1));
            return option;
          }));
          this.querySelector('[data-showcase-jump-wrapper]').hidden = false;
          this.jump.addEventListener('change', () => {
            this.paused = true;
            this.show(Number(this.jump.value));
            this.update();
          }, options);
        }
        this.querySelector('[data-showcase-previous]').addEventListener('click', () => this.move(-1, true), options);
        this.querySelector('[data-showcase-next]').addEventListener('click', () => this.move(1, true), options);
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.playThroughFocus = !this.paused && document.activeElement === this.toggle;
          this.playThroughHover = !this.paused && this.toggle.matches(':hover');
          this.update();
        }, options);
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
            this.hovered = true;
            this.update();
          }
        }, options);
        this.addEventListener('pointerover', (event) => {
          if (this.playThroughHover && !this.toggle.contains(event.target)) {
            this.playThroughHover = false;
            this.update();
          }
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.playThroughHover = false;
          this.update();
        }, options);
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.playThroughFocus = false;
          this.update();
        }, options);
        this.addEventListener('focusout', (event) => {
          this.focused = this.contains(event.relatedTarget);
          this.playThroughFocus = false;
          this.update();
        }, options);
        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') this.swipeStart = { x: event.clientX, y: event.clientY };
        }, options);
        this.track.addEventListener('pointerup', (event) => {
          if (!this.swipeStart) return;
          const deltaX = event.clientX - this.swipeStart.x;
          const deltaY = event.clientY - this.swipeStart.y;
          this.swipeStart = null;
          if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY) * 1.4) this.move(deltaX < 0 ? 1 : -1, true);
        }, options);
        this.track.addEventListener('pointercancel', () => { this.swipeStart = null; }, options);
        this.mobile.addEventListener('change', (event) => {
          if (event.matches) this.paused = true;
          this.update();
        }, options);
        document.addEventListener('visibilitychange', () => this.update(), options);
        this.motion.addEventListener('change', (event) => {
          if (event.matches) this.paused = true;
          this.update();
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const selected = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (selected < 0) return;
          this.paused = true;
          this.show(selected);
          this.update();
        }, options);
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= .15);
          this.update();
        }, { threshold: 0.15 });
        this.observer.observe(this);
        this.show(this.index);
        this.update();
      }

      reserveCaptionHeight() {
        this.captionSizer = document.createElement('div');
        this.captionSizer.className = 'rd-home__caption-measure';
        this.captionSizer.setAttribute('aria-hidden', 'true');
        this.captionSizer.inert = true;
        this.slides.forEach((entry) => {
          const slide = entry.tagName === 'TEMPLATE' ? entry.content.firstElementChild : entry;
          const caption = slide.querySelector('figcaption');
          if (!caption) return;
          const sample = document.createElement('figure');
          sample.className = slide.className.replace('rd-home__showcase-slide', '').trim();
          sample.append(caption.cloneNode(true));
          this.captionSizer.append(sample);
        });
        this.track.append(this.captionSizer);
        const resize = () => {
          const height = Math.ceil(this.captionSizer.getBoundingClientRect().height);
          if (height > 0) this.track.style.setProperty('--rd-review-caption-height', `${height}px`);
        };
        this.captionObserver = new ResizeObserver(resize);
        this.captionObserver.observe(this.captionSizer);
        resize();
      }

      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        const selected = this.slides[this.index];
        if (selected.tagName === 'TEMPLATE') {
          const slide = selected.content.firstElementChild.cloneNode(true);
          this.slides[this.index] = slide;
          selected.replaceWith(slide);
        }
        this.slides.forEach((slide, slideIndex) => {
          if (slide.tagName === 'TEMPLATE') return;
          const inactive = slideIndex !== this.index;
          slide.hidden = inactive;
          slide.inert = inactive;
          if (inactive) slide.setAttribute('aria-hidden', 'true');
          else slide.removeAttribute('aria-hidden');
        });
        this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
        this.count.setAttribute('aria-label', this.dataset.positionLabel.replace('[number]', String(this.index + 1)).replace('[total]', String(this.slides.length)));
        if (this.jump) this.jump.value = String(this.index);
      }

      move(direction, manual) {
        if (manual) this.paused = true;
        this.show(this.index + direction);
        this.update();
      }

      update() {
        window.clearTimeout(this.timer);
        const focusBlocked = this.focused && !(this.playThroughFocus && document.activeElement === this.toggle);
        const hoverBlocked = this.hovered && !this.playThroughHover;
        const stopped = this.paused || this.mobile.matches || this.motion.matches;
        this.toggleLabel.textContent = stopped ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.toggleIcon.textContent = stopped ? '▶' : 'Ⅱ';
        this.track.setAttribute('aria-live', stopped || focusBlocked || hoverBlocked ? 'polite' : 'off');
        if (stopped || focusBlocked || hoverBlocked || !this.visible || document.hidden) return;
        this.timer = window.setTimeout(() => this.move(1, false), 9000);
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.controller?.abort();
        this.observer?.disconnect();
        this.captionObserver?.disconnect();
        this.captionSizer?.remove();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-shop-designs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rd-design-collection')) {
    customElements.define('rd-design-collection', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
        this.generation = (this.generation || 0) + 1;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('.rd-designs__image')];
        this.dots = [...this.querySelectorAll('.rd-designs__dot')];
        this.button = this.querySelector('.rd-designs__pause');
        if (this.slides.length < 2 || !this.button) return;
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.failed = new Set();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.hoverPaused = false;
        this.visible = false;
        this.button.hidden = false;
        this.querySelector('.rd-designs__dots').hidden = false;
        this.updateButton();
        this.button.addEventListener('pointerdown', () => { this.pointerPaused = !this.paused; }, options);
        this.button.addEventListener('click', event => {
          this.paused = event.detail > 0 && typeof this.pointerPaused === 'boolean' ? this.pointerPaused : !this.paused;
          this.pointerPaused = undefined;
          if (!this.paused) this.hoverPaused = false;
          this.updateButton();
          this.schedule();
        }, options);
        this.addEventListener('mouseenter', () => { this.hoverPaused = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hoverPaused = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => {
          this.paused = true;
          this.updateButton();
          this.schedule();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.paused = true;
          this.updateButton();
          this.schedule();
        }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.2 });
        this.observer.observe(this);
      }
      updateButton() {
        this.button.setAttribute('aria-label', (this.paused ? this.dataset.playLabel : this.dataset.pauseLabel) + ': ' + this.dataset.title);
        this.button.querySelector('span').textContent = this.paused ? '▶' : '❚❚';
      }
      canPlay() { return this.isConnected && this.visible && !this.paused && !document.hidden && !this.hoverPaused; }
      schedule() {
        clearTimeout(this.timer);
        const generation = ++this.generation;
        if (!this.canPlay()) return;
        this.timer = setTimeout(() => this.advance(generation), 5200 + Number(this.dataset.offset || 0));
      }
      async advance(generation) {
        for (let step = 1; step < this.slides.length; step += 1) {
          const next = (this.index + step) % this.slides.length;
          if (this.failed.has(next)) continue;
          try { await this.slides[next].decode(); }
          catch {
            if (generation !== this.generation || !this.isConnected) return;
            this.failed.add(next);
            this.dots[next].hidden = true;
            continue;
          }
          if (generation !== this.generation || !this.canPlay()) return;
          this.slides[this.index].classList.remove('is-active');
          this.dots[this.index].classList.remove('is-active');
          this.slides[next].classList.add('is-active');
          this.dots[next].classList.add('is-active');
          this.index = next;
          this.schedule();
          return;
        }
        this.paused = true;
        this.button.hidden = true;
        this.querySelector('.rd-designs__dots').hidden = true;
      }
      disconnectedCallback() { this.generation += 1; this.controller?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
